import {
  StyleSheet,
  Text,
  View,
  Image
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  root: {
    position: 'relative'
  },
  title: {
    margin: '0 auto',
    paddingTop: 10,
    fontSize: 10,
    fontWeight: 700
  },

  donorAgreementContentWrapper: {
    fontSize: 9,
    padding: 10,
    lineHeight: 1.3
  },
  listWrapper: {
    marginBottom: 5,
    marginTop: 5
  },
  listHeading: {
    fontWeight: 500
  },
  subHeading: {
    paddingLeft: 5
  },
  agreeTermsBoxWrapper: {
    width: '70%',
    padding: 10,
    backgroundColor: '#add8e69e',
    margin: 10,
    position: 'absolute',
    bottom: -200,
    left: 5
  },
  checkboxImage: {
    width: 15,
    height: 15,
  },
  checkboxImagWithTextWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  textWrapper: {
    paddingLeft: 5
  },
  digitalSignatureBoxWrapper: {
    width: '100%',
    padding: 10,
    backgroundColor: '#fff',
    marginTop: 10,
  },
});

const PdfDonorAgreement = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    name, signDate, signTime
  } = props;
  return (
    <View style={styles.root}>
      <View style={styles.title}>
        <Text>Donor Agreement</Text>
      </View>
      <View />
      <View style={styles.donorAgreementContentWrapper}>

        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>1. Purpose</Text>
          <Text>I understand that I have been sent to Avertest LLC d/b/a averhealth for sample collection and testing. averhealth&apos;s role and purpose is to competently perform these functions and, by doing so, help me to achieve and maintain sobriety and succeed in my treatment, recovery, and/or supervision program.
          </Text>
        </View>

        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>2. Free Will.</Text>
          <Text>I understand that I am participating in the averhealth testing and collection process voluntarily and of my own free will. While I may have to answer to a treatment provider, a case manager, and/or a court, averhealth and averhealth staff have no authority over me and cannot require me to do anything against my will. I understand that averhealth does not set or control any provisions, conditions, or requirements for my treatment or supervision program and that they are merely providing services as ordered by my treatment provider, case manager, and/or judge
          </Text>
        </View>
        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>3. Mutual Respect.</Text>
          <Text>
            I understand that averhealth is a partner in my treatment, recovery, and/or supervision. averhealth will treat me with respect, and I will treat the averhealth staff with respect. I also understand that the averhealth staff has an important and sometimes challenging job. Similarly, averhealth understands that the procedures it performs may be uncomfortable or a source of stress for me. We will each be courteous, non-confrontational, and non-argumentative with one another and with other people in and around the averhealth location
          </Text>
        </View>
        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>4. Test Orders.</Text>
          <Text>Concerning my testing, I understand that I must:</Text>
          <View style={styles.subHeading}>
            <Text>a. Appear for testing at an approved collection location when randomly selected or otherwise instructed by the court, or my probation, treatment, or similar agency.</Text>
            <Text>b. Call the averhealth notification line or receive and respond to the averhealth text notifications promptly and during the day they are received.I understand that I must listen to or read the entire scheduling notification to hear my scheduling information, test location hours of operation, other messages/ alerts, and my confirmation number.</Text>
            <Text>c. Pay a pre - determined test fee each time I arrive for my drug test via cash, credit card, my prepay account, and / or accepted insurance coverage.</Text>
          </View>

        </View>
        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>5. Same Gender, Observed Urine Collections</Text>
          <Text>
            I understand that averhealth follows same-gender observed urine collection procedures that are approved by my court, case manager, and/or treatment provider and recommended by the National Association of Drug Court Professionals, the American Society of Addiction Medicine, and other similar organizations. I understand that these procedures are designed for my benefit and to help me. I agree to:
          </Text>
          <View style={styles.subHeading}>
            <Text>
              a. Allow an averhealth collection technician of the same gender to accompany me into the collection room.
            </Text>
            <Text>
              b. Ensure the averhealth collection technician has an unobstructed view of urine flowing from my urethra into the collection cup by removing any coats or bulky outer garments, raising my shirt above my mid-section, lowering my bottoms to mid-thigh and turning around in a complete circle prior to providing a sample.
            </Text>
            <Text>
              c. Comply with other collection protocols as requested by my program. These protocols may include that I provide a ‘mid steam sample’, but in NO case will these protocols include processes that are against averhealth policy, including physical contact, any recording (e.g., audio, image, or video), or cavity searches (other than a visual inspection on the mouth during an oral fluid collection). d. Alert my probation officer, case manager, and/or treatment counselor as well as the local averhealth manager via confidential email at service@averhealth.com regarding my concerns related to the testing program or collection process.
            </Text>
          </View>

        </View>
        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>6. Test Results.</Text>
          <Text>
            I understand that averhealth is not permitted to discuss the results of my tests with me at any time and that test results will be reported directly to the court, my probation or treatment agency and other approved parties.
          </Text>
        </View>
        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>7. Consent, Waiver, & Release.</Text>
          <Text>
            I voluntarily and knowingly consent to and agree to participate in the testing and same-gender, observed collection process to be conducted by averhealth and its employees. I understand that my participation in the averhealth testing and collection process is an approved condition of my treatment and/or supervision program, has been voluntarily agreed to by me, and does not constitute a violation of my constitutional rights. averhealth does not set or control the conditions of my treatment and/or supervision program. averhealth also does not control the actions taken by the treatment and/or supervision program based on the test and information generated by averhealth. In consideration of these facts, I agree to release averhealth from liability for, and waive my right to sue averhealth as a result of any and all claims arising from or related to my participation in the drug testing program and averhealth’s collection and testing services.
          </Text>
        </View>
        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>8. Governing Law & Venue.</Text>
          <Text>
            I voluntarily and knowingly agree that this agreement shall be governed by the laws of the state where services are provided and that venue for any action brought pursuant to this agreement shall be in the local judicial district where those services are provided.
          </Text>
        </View>
        <View style={styles.listWrapper} break>
          <Text style={styles.listHeading}>9. Severability.</Text>
          <Text>
            If any provision of this agreement is or may be held by a court of competent jurisdiction to be invalid, void or unenforceable, the remaining provisions shall nevertheless survive and continue in full force and effect without being impaired or invalidated in any way.
          </Text>
        </View>
        <View style={styles.listWrapper}>
          <Text style={styles.listHeading}>10. Agreement.</Text>
          <Text>
            I HAVE CAREFULLY READ THIS AGREEMENT, UNDERSTAND ITS CONTENTS AND SIGN THIS AGREEMENT AS MY OWN FREE ACT. THE AGREEMENT REPRESENTS THE ENTIRE AGREEMENT BETWEEN AVERHEALTH AND ME, AND THIS AGREEMENT SUPERCEDES ANY OTHER AGREEMENT WHETHER VERBAL OR WRITTEN. THIS AGREEMENT MAY ONLY BE MODIFIED WITH EXPLICITLY WRITTEN APPROVAL OF AN AVERHEALTH EXECUTIVE OFFICER.
          </Text>
        </View>
      </View>
      <View style={styles.agreeTermsBoxWrapper}>
        <View style={styles.checkboxImagWithTextWrapper}>
          <View style={styles.imageWrapper}>
            <Image
              style={styles.checkboxImage}
              src="assets/images/checkbox.png"
            />
          </View>
          <View style={styles.textWrapper}>
            <Text style={{ fontSize: 11 }}>
              I agree that I am {name} or their legal guardian.
            </Text>
          </View>
        </View>
        <View style={styles.checkboxImagWithTextWrapper}>
          <View style={styles.imageWrapper}>
            <Image
              style={styles.checkboxImage}
              src="assets/images/checkbox.png"
            />
          </View>
          <View style={styles.textWrapper}>
            <Text style={{ fontSize: 11 }}>
              I agree to the terms of Donor Agreement
            </Text>
          </View>
        </View>
        <View style={styles.digitalSignatureBoxWrapper}>
          <Text style={{ fontFamily: 'signature', fontSize: 20 }}>{name}</Text>
          <Text style={{ fontFamily: 'Opan Sans Italic' }}>Electronically Signed on {signDate} at {signTime}</Text>
        </View>
      </View>
    </View>
  );
};

export default PdfDonorAgreement;
